import React, { useEffect, useState } from 'react'
import { InputProp } from '../../utils/tsConfig'


const Hide: React.FC<InputProp> = (props) => {
  const {  keyId, setState, state, isArray,  indexVal, arrayName,max,min,  className, returnKey, fieldName,  onChange, required = false, disabled = false } = props;
  const [selected, setSelected] = useState("");
 
  const onChangeValue = (e: any) => {
    if (isArray) {
      if (arrayName && indexVal !== undefined && returnKey && setState) {
        if (state[arrayName] && state[arrayName][indexVal] && state[arrayName][indexVal][returnKey]) {
          const updatedState = { ...state };
          updatedState[arrayName][indexVal][returnKey] = e.target.value;
          setState(updatedState);
          setSelected(e.target.value);
        } else {
          const updatedState = { ...state };
          if (!updatedState[arrayName]) {
            updatedState[arrayName] = [];
          }
          while (updatedState[arrayName].length <= indexVal) {
            updatedState[arrayName].push({});
          }
          if (typeof updatedState[arrayName][indexVal] !== "object" || updatedState[arrayName][indexVal] === null) {
            updatedState[arrayName][indexVal] = {};
          }
          updatedState[arrayName][indexVal][returnKey] = e.target.value;
          setState(updatedState);
          setSelected(e.target.value);
        }
      }
    } else {
      if (onChange) {
        onChange({ value: e.target.value });
      }
      if (setState) {
        if (returnKey) {
          setState({ ...state, [returnKey]: e.target.value });
        } else {
          setState(e.target.value);
        }
      }

    }
  }

  useEffect(() => {
    if (isArray) {
      if (arrayName && indexVal !== undefined && returnKey) {
        if (state[arrayName] && state[arrayName][indexVal] && state[arrayName][indexVal][returnKey]) {
          setSelected(state[arrayName][indexVal][returnKey]);
        }
      }
    } else {
      if (returnKey) {
        setSelected(state[returnKey]);
      } else {
        setSelected(state);
      }
    }
  }, [returnKey, state, isArray, arrayName, indexVal,]);




  return (
    <label key={keyId} className={`customInput ${className}`} >
      <input
        value={selected || ""}

        required={required}
        maxLength={max}
        minLength={min}
        disabled={disabled}
        className="input__field outline-none border border-gray-200 rounded-md lg:text-sm xl:text-md lg:text-left md:text-center"
        onChange={onChangeValue}
        type={'hidden'}
        placeholder=" "
      />
      <span className="input__label">
        {fieldName.replace(/\*$/, "")}
        {fieldName.endsWith("*") && <span className="mandatory-asterisk">*</span>}
      </span>
    </label>
  )
}

export default Hide